var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedikdomLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.127,
    height: 95.91,
    viewBox: "0 0 261.127 95.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(-378.873 -78.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(378.873 78.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(3.789 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 31.893,
    cy: 31.893,
    r: 31.893,
    transform: "translate(0.003 32.125)",
    fill: "#e22c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M-219.794,5467.393h63.785s.976-32.848-31.893-64.017C-220.77,5434.545-219.794,5467.393-219.794,5467.393Z",
    transform: "translate(219.797 -5403.376)",
    fill: "#e22c2c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M-184.7,5556.3l-1.225-.754a60.571,60.571,0,0,1-6.989-4.981,51.631,51.631,0,0,1-12.96-18.971l-.1-.24a30.417,30.417,0,0,0-1.2-4.268l-.811-2.08-2.176.5a71.4,71.4,0,0,1-8.455,1.39,17.359,17.359,0,0,0-4.238-10.641,127.876,127.876,0,0,0-19.007-17.23c-5.967-4.559-10.583-7.573-10.776-7.7l-2.38-1.551-3.111-2.027-.849,3.743-.5,2.8a15.839,15.839,0,0,0,.08,4.925,22,22,0,0,0,.833,3.546,14.16,14.16,0,0,0-.3,1.625,10.843,10.843,0,0,0,.778,5.8c-.006.1-.011.2-.014.3a25.058,25.058,0,0,0,.346,7.1,13.619,13.619,0,0,0,3.135,6.523,18.88,18.88,0,0,0,.885,4.9,15.31,15.31,0,0,0,6.587,8.494,17.994,17.994,0,0,0,4.218,4.5,23.378,23.378,0,0,0,7.036,3.627c.67.217,1.363.414,2.076.585a6.612,6.612,0,0,0-.319,2.243l.025,1.278,1.03.757a96.483,96.483,0,0,0,11.414,6.827c4.251,2.224,8.767,4.307,13.424,6.19a164.49,164.49,0,0,0,18,6.082l1.144.314,1.133-.768a6.215,6.215,0,0,0,2.156-3.673l.109-.6a7.135,7.135,0,0,0,.734-.893,7.883,7.883,0,0,0,1.344-3.783h0a27,27,0,0,0,.128-2.873l0-.274Z",
    transform: "translate(259.625 -5478.01)",
    fill: "#e22c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(2.587 13.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(25.491 36.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M4.8,5859.811l17.436-1.708a52.147,52.147,0,0,0,22.882,28.538s1.093,7.6-12.212,2.685-25.933-11.454-28.843-14.479S4.962,5868.976,4.8,5859.811Z",
    transform: "translate(-0.738 -5855.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M12,5890.049s8.064,3.735,9.055,9.244a22,22,0,0,1-.307,9.625s-9.482-3.171-9.846-7.291S12,5890.049,12,5890.049Z",
    transform: "translate(-7.712 -5883.903)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M7.851,5901.977a3.869,3.869,0,0,1-.4-1.21,11.107,11.107,0,0,1,.579-4.355,29.071,29.071,0,0,0,.881-8.664c.575.313,1.167.6,1.729.933.149.088.3.177.449.263a33.163,33.163,0,0,1-.646,6.8c-.764,3.642-1.289,5.321-.568,7.672A23.974,23.974,0,0,1,7.851,5901.977Z",
    transform: "translate(-4.654 -5881.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M16.628,5964.875c-.511,2.2.87,5.388,3.6,7.3l-5.384-2.726,1.555-5.72Z",
    transform: "translate(-11.251 -5949.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M113.864,5965.835s-5.726-.1-8.6,2.823a28.416,28.416,0,0,0-4.847,7.66l12.506,5.7a13.6,13.6,0,0,1,6.554-8.366Z",
    transform: "translate(-86.946 -5950.943)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M106.809,5967.178s-10.095-.089-13.048,10.215l-2.454-1.352s3.565-9.521,14.247-10.527Z",
    transform: "translate(-78.886 -5950.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M111.685,6045.116a113.509,113.509,0,0,1-12.612-6.248l-1.217,3.418,11.524,6Z",
    transform: "translate(-84.681 -6015.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M.458,5863.264a46.218,46.218,0,0,0,8.023-.032,45.116,45.116,0,0,0,8.009-1.385A55.7,55.7,0,0,0,30.7,5882.626a66.864,66.864,0,0,0,7.722,5.535c-.159,1.621-1.129,2.49-2.98,2.653-1.729.153-4.228-.311-7.553-1.354-6.885-2.161-15.279-6.774-20.136-8.977s-8.508-3.859-8.551-6.907c-.019-1.345.677-3.745.869-5.309a48.557,48.557,0,0,0,.388-5m-2.282-2.51-.024,2.49a47.153,47.153,0,0,1-.371,4.743c-.065.53-.21,1.229-.363,1.967a18.463,18.463,0,0,0-.523,3.656c.03,2.176,1.159,4.017,3.451,5.625a41.313,41.313,0,0,0,6.454,3.35c1.335.6,3,1.426,4.767,2.294a118.874,118.874,0,0,0,15.63,6.781c3.727,1.17,6.412,1.632,8.447,1.451,2.954-.262,4.8-1.983,5.072-4.726l.14-1.434-1.225-.755a64.64,64.64,0,0,1-7.376-5.274A54.22,54.22,0,0,1,18.633,5861l-.778-1.954-2.018.593a43.485,43.485,0,0,1-7.56,1.3,43.81,43.81,0,0,1-7.621.032l-2.481-.213Z",
    transform: "translate(4.631 -5856.475)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(4.362 5.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M31.034,5903.606l-1.168-.323c.007-.03.06-.276.189-.675.413-1.646,1.272-6.365-1.045-10.652A15.213,15.213,0,0,0,21.476,5885l.392-1.148a16.233,16.233,0,0,1,8.209,7.526,15.071,15.071,0,0,1,1.7,7.746c.2-.3.428-.61.674-.92,1.867-2.352,5.408-5.261,11.677-5.777l.1,1.209c-4.685.386-8.328,2.178-10.827,5.323a13.183,13.183,0,0,0-2.159,3.932C31.134,5903.306,31.05,5903.558,31.034,5903.606Z",
    transform: "translate(-21.476 -5883.854)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(25.621 22.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M206.886,6038.856l-1.192-.228a13.044,13.044,0,0,1,7.453-9.478l.447,1.127A12.044,12.044,0,0,0,206.886,6038.856Z",
    transform: "translate(-205.694 -6029.151)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M-13.734,5990.844a7.324,7.324,0,0,0-1.95.439,2.867,2.867,0,0,0-.635,2.167s15.555,11.424,41.987,18.689a3.658,3.658,0,0,0,1.2-2.091,13.477,13.477,0,0,0-1.894-2.018s-9.243.405-23.346-6.644S-13.734,5990.844-13.734,5990.844Z",
    transform: "translate(16.321 -5973.066)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M323.588,6096.871a8.54,8.54,0,0,1-1.8-1.042,1.866,1.866,0,0,1-.741-1.337,1.247,1.247,0,0,0,.131,1.693A3.728,3.728,0,0,0,323.588,6096.871Z",
    transform: "translate(-281.869 -6064.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M7.913,5843.089a35.938,35.938,0,0,1,0-4.479,74.7,74.7,0,0,0,19.1-1.815,29.7,29.7,0,0,1,1.256,4.725l-10.934.6Z",
    transform: "translate(-5.052 -5836.795)",
    fill: "#1a1b1d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M27.879,5975.569l-.5.478a8.216,8.216,0,0,1-2.928,1.318l.064-1.855Z",
    transform: "translate(5.749 -5923.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M-194.614,5588.232a5.091,5.091,0,0,1-2.08-.469c-.507.018-1.012.027-1.5.027-8.053,0-12.9-2.418-15.544-4.446a13.578,13.578,0,0,1-3.8-4.3,11.784,11.784,0,0,1-5.8-6.986,14.993,14.993,0,0,1-.711-5.337,9.343,9.343,0,0,1-3.211-5.718,21.455,21.455,0,0,1-.275-6.164,8.086,8.086,0,0,1,.119-1.211c-1.662-2.553-.782-5.754-.395-6.861a16.986,16.986,0,0,1-1.059-3.957,12.508,12.508,0,0,1-.093-3.769l.248-1.4,1.19.776c.185.12,18.627,12.2,29.037,24.277a13.791,13.791,0,0,1,3.392,9.354c0,.072,0,.144-.007.216v.021c-.019.464-.031.874-.037,1.254a9.273,9.273,0,0,0,.956,5.124l.008.016a18.807,18.807,0,0,1,1.857,8.345l-.022.561-.5.247a3.982,3.982,0,0,1-1.766.4Z",
    transform: "translate(230 -5536.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M-235.249,5527.226s18.395,11.985,28.838,24.1a12.885,12.885,0,0,1,3.164,8.718c0,.072,0,.146-.007.22h0c-.019.46-.032.884-.038,1.28a10.177,10.177,0,0,0,1.065,5.578,17.985,17.985,0,0,1,1.756,7.884,3.049,3.049,0,0,1-1.353.305,4.151,4.151,0,0,1-1.875-.477q-.879.037-1.71.036c-15.08,0-18.636-8.5-18.636-8.5-6.454-3.158-6.425-10.437-6.251-11.863.016-.135.029-.213.029-.213-3.746-2.413-3.835-8.362-3.542-11.378a6.307,6.307,0,0,1,.186-1.47c-2.09-2.708-.387-6.679-.387-6.679a15.935,15.935,0,0,1-1.143-4.08,11.591,11.591,0,0,1-.1-3.459m-1.354-3.126-.5,2.8a13.306,13.306,0,0,0,.089,4.076,18.3,18.3,0,0,0,.988,3.845,11.8,11.8,0,0,0-.443,2.04,7.967,7.967,0,0,0,.856,4.984,9.223,9.223,0,0,0-.076.959,22.392,22.392,0,0,0,.294,6.412,10.5,10.5,0,0,0,3.173,5.955,16.315,16.315,0,0,0,.776,5.2,12.715,12.715,0,0,0,6,7.39,14.76,14.76,0,0,0,3.92,4.353,20.8,20.8,0,0,0,6.262,3.219,31.961,31.961,0,0,0,9.854,1.421c.433,0,.876-.007,1.322-.021a6,6,0,0,0,2.262.462,4.926,4.926,0,0,0,2.179-.5l1.008-.494.044-1.122a19.852,19.852,0,0,0-1.957-8.807l-.008-.017-.008-.015c-.6-1.139-.885-2.127-.846-4.668.006-.37.017-.768.036-1.218l0-.039v-.014q0-.1.007-.209a14.732,14.732,0,0,0-3.619-9.993,125.234,125.234,0,0,0-18.618-16.862c-5.892-4.5-10.428-7.465-10.618-7.589l-2.38-1.552Z",
    transform: "translate(237.21 -5524.099)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(1.594 13.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(5.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M-146.8,5668.873a4.215,4.215,0,0,1-1.47-1.27,9.92,9.92,0,0,1-1.817-5.455l-.006-.074c-.234-3-.389-4.978-1.643-7.159-1.212-2.11-3.44-4.371-7.945-8.06-2.169-1.777-4.084-3.3-5.737-4.591a66.338,66.338,0,0,0-6.724-4.516,40.5,40.5,0,0,0,4.842,4.484l0,0c1.893,1.457,4.2,3.277,6.9,5.494,8.6,7.043,8.723,8.609,9.178,14.436l.006.073a15.436,15.436,0,0,0,.328,2.213C-149.677,5668.833-146.8,5668.873-146.8,5668.873Z",
    transform: "translate(172.138 -5637.747)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(0 2.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M-222.391,5656.786l-1,.246a11.929,11.929,0,0,0,3.414,4.959,18.035,18.035,0,0,0,6.621,4.028C-218.546,5662.413-221.838,5659.049-222.391,5656.786Z",
    transform: "translate(223.395 -5656.786)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(0.769 13.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M-215.78,5752.492l-.955.4a11.923,11.923,0,0,0,4.131,4.378,18.042,18.042,0,0,0,7.159,2.971C-211.121,5757.466-214.888,5754.644-215.78,5752.492Z",
    transform: "translate(216.735 -5752.492)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(8.357 27.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M-150.612,5876.1q-.178.5-.369,1c.58.385,1.208.752,1.864,1.1a18.023,18.023,0,0,0,7.5,1.97A37.2,37.2,0,0,1-150.612,5876.1Z",
    transform: "translate(150.981 -5876.102)",
    fill: "#1a1b1d"
  })))))))), /*#__PURE__*/React.createElement("text", {
    id: "MEDIK_DOM",
    "data-name": "MEDIK\\u2019DOM",
    transform: "translate(566 134.125)",
    fill: "#1a1b1d",
    fontSize: 25,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -73.165,
    y: 0
  }, "MEDIK\u2019DOM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedikdomLogo);
export default __webpack_public_path__ + "static/media/medikdom-logo.f2c85ede9a5c53e7cf82357a9c86ef72.svg";
export { ForwardRef as ReactComponent };